/** Side-effect import - must load before App (see main.tsx). */
import { initSentry } from "./sentry";

initSentry();
